<ng-container>
    <div class="mx-5 my-4 mailkit-container">
        <form [formGroup]="mailKitForm">
            <div class="px-2">
                <div class="quote-container">
                    <button class="btn btn-sm btn-primary my-1" (click)="toggleReadOnly()"> Edit </button>
                  </div>
                <h4 class="mb-5 mt-3">Mail Kit</h4>
                <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                            [ngClass]="{'border-danger': mailKitForm.get('smtpServer')?.invalid && mailKitForm.get('smtpServer')?.touched && !isReadOnly()}">SMTP
                            Server</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                            [ngClass]="{'border-danger': mailKitForm.get('smtpServer')?.invalid && mailKitForm.get('smtpServer')?.touched && !isReadOnly()}"
                            formControlName="smtpServer" placeholder="" name="smtpServer" maxlength="256" />
                        @if (mailKitForm.get('smtpServer')?.invalid && mailKitForm.get('smtpServer')?.touched && !isReadOnly()) {
                        <span class="text-danger">
                            @if (mailKitForm.get('smtpServer')?.errors?.['required']) {
                            SMTP Server is required.
                            }
                            @else if (mailKitForm.get('smtpServer')?.errors?.['pattern']) {
                            SMTP Server must be alphanumeric.
                            }
                            @else if (mailKitForm.get('smtpServer')?.errors?.['maxlength']) {
                            SMTP Server must be no longer than 256 characters.
                            }
                        </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                            [ngClass]="{'border-danger': mailKitForm.get('smtpPort')?.invalid && mailKitForm.get('smtpPort')?.touched && !isReadOnly()}">SMTP
                            Port</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                            [ngClass]="{'border-danger': mailKitForm.get('smtpPort')?.invalid && mailKitForm.get('smtpPort')?.touched && !isReadOnly()}"
                            formControlName="smtpPort" placeholder="" name="smtpPort" />
                        @if (mailKitForm.get('smtpPort')?.invalid && mailKitForm.get('smtpPort')?.touched && !isReadOnly()) {
                        <span class="text-danger">
                            @if (mailKitForm.get('smtpPort')?.errors?.['required']) {
                            SMTP Port is required.
                            }
                            @else if (mailKitForm.get('smtpPort')?.errors?.['pattern']) {
                            SMTP Port must be integer.
                            }
                        </span>
                        }
                    </div>
                </div>
                <!-- <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                            [ngClass]="{'border-danger': mailKitForm.get('userName')?.invalid && mailKitForm.get('userName')?.touched && !isReadOnly()}">User
                            name</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                            [ngClass]="{'border-danger': mailKitForm.get('userName')?.invalid && mailKitForm.get('userName')?.touched && !isReadOnly()}"
                            formControlName="userName" placeholder="" name="userName" maxlength="256" />
                        @if (mailKitForm.get('userName')?.invalid && mailKitForm.get('userName')?.touched && !isReadOnly()) {
                        <span class="text-danger">
                            @if (mailKitForm.get('userName')?.errors?.['required']) {
                            User name is required.
                            }
                            @else if (mailKitForm.get('userName')?.errors?.['pattern']) {
                            User name must be alphanumeric.
                            }
                            @else if (mailKitForm.get('userName')?.errors?.['maxlength']) {
                            User name must be no longer than 256 characters.
                            }
                        </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                            [ngClass]="{'border-danger': mailKitForm.get('password')?.invalid && mailKitForm.get('password')?.touched && !isReadOnly()}">Password</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                            [ngClass]="{'border-danger': mailKitForm.get('password')?.invalid && mailKitForm.get('password')?.touched && !isReadOnly()}"
                            formControlName="password" placeholder="" name="password" maxlength="256" />
                        @if (mailKitForm.get('password')?.invalid && mailKitForm.get('password')?.touched && !isReadOnly()) {
                        <span class="text-danger">
                            @if (mailKitForm.get('password')?.errors?.['required']) {
                            Password is required.
                            }
                            @else if (mailKitForm.get('password')?.errors?.['pattern']) {
                            Password must be alphanumeric.
                            }
                            @else if (mailKitForm.get('password')?.errors?.['maxlength']) {
                            Password must be no longer than 256 characters.
                            }
                        </span>
                        }
                    </div>
                </div> -->
                <div class="row mb-5 mt-6">
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                            [ngClass]="{'border-danger': mailKitForm.get('protocol')?.invalid && mailKitForm.get('protocol')?.touched && !isReadOnly()}">TLS
                            / SSL</label>
                        <div class="pt-8 ps-4">
                            <input type="radio" class="form-check-input me-2" id="tls" formControlName="protocol" [readOnly]="isReadOnly()"
                                name="protocol" [value] ="1" />
                            <label class="form-check-label me-5" for="tls">TLS</label>
                            <input type="radio" class="form-check-input me-2" id="ssl" formControlName="protocol" [readOnly]="isReadOnly()"
                                name="protocol" [value] ="0" />
                            <label class="form-check-label me-5" for="ssl">SSL</label>
                        </div>

                        @if (mailKitForm.get('protocol')?.invalid && mailKitForm.get('protocol')?.touched && !isReadOnly()) {
                        <span class="text-danger">
                            @if (mailKitForm.get('protocol')?.errors?.['required']) {
                            TLS / SSL is required.
                            }
                        </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 mb-5 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                            [ngClass]="{'border-danger': mailKitForm.get('bccEmail')?.invalid && mailKitForm.get('bccEmail')?.touched && !isReadOnly()}">BCC
                            Email</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                            [ngClass]="{'border-danger': mailKitForm.get('bccEmail')?.invalid && mailKitForm.get('bccEmail')?.touched && !isReadOnly()}"
                            formControlName="bccEmail" placeholder="" name="bccEmail" maxlength="64" />
                        @if (mailKitForm.get('bccEmail')?.invalid && mailKitForm.get('bccEmail')?.touched && !isReadOnly()) {
                        <span class="text-danger">
                            @if (mailKitForm.get('bccEmail')?.errors?.['required']) {
                            BCC Email is required.
                            }
                            @else if (mailKitForm.get('bccEmail')?.errors?.['pattern']) {
                            BCC Email must be alphanumeric.
                            }
                            @else if (mailKitForm.get('bccEmail')?.errors?.['maxlength']) {
                            BCC Email must be no longer than 64 characters.
                            }
                        </span>
                        }
                    </div>
                </div>
            </div>
            <div class="px-2 mt-5">
                <h4 class="mb-5">User Creation</h4>
                <div class="mt-5">
                    <div class="row mb-5 mt-6">
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('createUserFromEmail')?.invalid && mailKitForm.get('createUserFromEmail')?.touched && !isReadOnly()}">From</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('createUserFromEmail')?.invalid && mailKitForm.get('createUserFromEmail')?.touched && !isReadOnly()}"
                                formControlName="createUserFromEmail" placeholder="" name="createUserFromEmail"
                                maxlength="64" />
                            @if (mailKitForm.get('createUserFromEmail')?.invalid &&
                            mailKitForm.get('createUserFromEmail')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('createUserFromEmail')?.errors?.['required']) {
                                From is required.
                                }
                                @else if (mailKitForm.get('createUserFromEmail')?.errors?.['pattern']) {
                                From must be alphanumeric.
                                }
                                @else if (mailKitForm.get('createUserFromEmail')?.errors?.['maxlength']) {
                                From must be no longer than 64 characters.
                                }
                            </span>
                            }
                        </div>
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('createUserFromName')?.invalid && mailKitForm.get('createUserFromName')?.touched && !isReadOnly()}">From
                                Name</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('createUserFromName')?.invalid && mailKitForm.get('createUserFromName')?.touched && !isReadOnly()}"
                                formControlName="createUserFromName" placeholder="" name="createUserFromName"
                                maxlength="64" />
                            @if (mailKitForm.get('createUserFromName')?.invalid &&
                            mailKitForm.get('createUserFromName')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('createUserFromName')?.errors?.['required']) {
                                From Name is required.
                                }
                                @else if (mailKitForm.get('createUserFromName')?.errors?.['pattern']) {
                                From Name must be alphanumeric.
                                }
                                @else if (mailKitForm.get('createUserFromName')?.errors?.['maxlength']) {
                                From Name must be no longer than 64 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                    <div class="row mb-5 mt-6">
                        <div class="col-12 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('createUserSubject')?.invalid && mailKitForm.get('createUserSubject')?.touched && !isReadOnly()}">Subject</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('createUserSubject')?.invalid && mailKitForm.get('createUserSubject')?.touched && !isReadOnly()}"
                                formControlName="createUserSubject" placeholder="" name="createUserSubject"
                                maxlength="256" />
                            @if (mailKitForm.get('createUserSubject')?.invalid &&
                            mailKitForm.get('createUserSubject')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('createUserSubject')?.errors?.['required']) {
                                Subject is required.
                                }
                                @else if (mailKitForm.get('createUserSubject')?.errors?.['pattern']) {
                                Subject must be alphanumeric.
                                }
                                @else if (mailKitForm.get('createUserSubject')?.errors?.['maxlength']) {
                                Subject must be no longer than 256 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                    <div class="row mb-5 mt-6">
                        <div class="col-12 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('createUserMailBody')?.invalid && mailKitForm.get('createUserMailBody')?.touched && !isReadOnly()}">Mail
                                Body</label>
                            <textarea type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('createUserMailBody')?.invalid && mailKitForm.get('createUserMailBody')?.touched}"
                                rows="4" maxlength="256" formControlName="createUserMailBody" placeholder=""
                                name="createUserMailBody"></textarea>
                            @if (mailKitForm.get('createUserMailBody')?.invalid &&
                            mailKitForm.get('createUserMailBody')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('createUserMailBody')?.errors?.['required']) {
                                Mail Body is required.
                                }
                                @else if (mailKitForm.get('createUserMailBody')?.errors?.['maxlength']) {
                                Mail Body must be no longer than 256 characters.
                                }
                            </span>
                            }
                        </div>
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('mailExpiryInDays')?.invalid && mailKitForm.get('mailExpiryInDays')?.touched && !isReadOnly()}">Expiry
                                in Days</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('mailExpiryInDays')?.invalid && mailKitForm.get('mailExpiryInDays')?.touched && !isReadOnly()}"
                                formControlName="mailExpiryInDays" placeholder="" name="mailExpiryInDays" />
                            @if (mailKitForm.get('mailExpiryInDays')?.invalid &&
                            mailKitForm.get('mailExpiryInDays')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('mailExpiryInDays')?.errors?.['required']) {
                                Expiry in days is required.
                                }
                                @else if (mailKitForm.get('mailExpiryInDays')?.errors?.['pattern']) {
                                Expiry in days must be interger.
                                }
                            </span>
                            }
                        </div>
                    </div>

                </div>
            </div>
            <div class="px-2 mt-5">
                <h4 class="mb-5">Forgot & Reset Password</h4>
                <div class="mt-5">
                    <div class="row mb-5 mt-6">
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('forgotUserFromEmail')?.invalid && mailKitForm.get('forgotUserFromEmail')?.touched && !isReadOnly()}">From</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('forgotUserFromEmail')?.invalid && mailKitForm.get('forgotUserFromEmail')?.touched && !isReadOnly()}"
                                formControlName="forgotUserFromEmail" placeholder="" name="forgotUserFromEmail"
                                maxlength="64" />
                            @if (mailKitForm.get('forgotUserFromEmail')?.invalid &&
                            mailKitForm.get('forgotUserFromEmail')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('forgotUserFromEmail')?.errors?.['required']) {
                                From is required.
                                }
                                @else if (mailKitForm.get('forgotUserFromEmail')?.errors?.['pattern']) {
                                From must be alphanumeric.
                                }@else if (mailKitForm.get('forgotUserFromEmail')?.errors?.['maxlength']) {
                                From must be no longer than 64 characters.
                                }
                            </span>
                            }
                        </div>
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('forgotUserFromName')?.invalid && mailKitForm.get('forgotUserFromName')?.touched && !isReadOnly()}">From
                                Name</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('forgotUserFromName')?.invalid && mailKitForm.get('forgotUserFromName')?.touched && !isReadOnly()}"
                                formControlName="forgotUserFromName" placeholder="" name="forgotUserFromName"
                                maxlength="64" />
                            @if (mailKitForm.get('forgotUserFromName')?.invalid &&
                            mailKitForm.get('forgotResetPwdfrom')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('forgotUserFromName')?.errors?.['required']) {
                                From Name is required.
                                }
                                @else if (mailKitForm.get('forgotUserFromName')?.errors?.['pattern']) {
                                From Name must be alphanumeric.
                                }@else if (mailKitForm.get('forgotUserFromName')?.errors?.['maxlength']) {
                                From Name must be no longer than 64 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                    <div class="row mb-5 mt-6">
                        <div class="col-12 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('forgotUserSubject')?.invalid && mailKitForm.get('forgotUserSubject')?.touched && !isReadOnly()}">Subject</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('forgotUserSubject')?.invalid && mailKitForm.get('forgotUserSubject')?.touched && !isReadOnly()}"
                                formControlName="forgotUserSubject" placeholder="" name="forgotUserSubject"
                                maxlength="256" />
                            @if (mailKitForm.get('forgotUserSubject')?.invalid &&
                            mailKitForm.get('forgotUserSubject')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('forgotUserSubject')?.errors?.['required']) {
                                Subject is required.
                                }
                                @else if (mailKitForm.get('forgotUserSubject')?.errors?.['pattern']) {
                                Subject must be alphanumeric.
                                }@else if (mailKitForm.get('forgotUserSubject')?.errors?.['maxlength']) {
                                Subject must be no longer than 256 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                    <div class="row mb-5 mt-6">
                        <div class="col-12 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('forgotUserMailBody')?.invalid && mailKitForm.get('forgotUserMailBody')?.touched && !isReadOnly()}">Mail
                                Body</label>
                            <textarea type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('forgotUserMailBody')?.invalid && mailKitForm.get('forgotUserMailBody')?.touched && !isReadOnly()}"
                                rows="4" maxlength="256" formControlName="forgotUserMailBody" placeholder=""
                                name="forgotUserMailBody"></textarea>
                            @if (mailKitForm.get('forgotUserMailBody')?.invalid &&
                            mailKitForm.get('forgotUserMailBody')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('forgotUserMailBody')?.errors?.['required']) {
                                Mail Body is required.
                                }@else if (mailKitForm.get('forgotUserMailBody')?.errors?.['maxlength']) {
                                Mail Body must be no longer than 256 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                    <div class="row mb-5 mt-6">
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('resetExpiryInMins')?.invalid && mailKitForm.get('resetExpiryInMins')?.touched && !isReadOnly()}">Expiry
                                in mins</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('resetExpiryInMins')?.invalid && mailKitForm.get('resetExpiryInMins')?.touched && !isReadOnly()}"
                                placeholder="" formControlName="resetExpiryInMins" name="resetExpiryInMins" />
                            @if (mailKitForm.get('resetExpiryInMins')?.invalid &&
                            mailKitForm.get('resetExpiryInMins')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('resetExpiryInMins')?.errors?.['required']) {
                                Expiry in mins is required.
                                }
                                @else if (mailKitForm.get('resetExpiryInMins')?.errors?.['pattern']) {
                                Expiry in mins must be integer.
                                }
                            </span>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div class="px-2 mt-5">
                <h4 class="mb-5">Expiry Mail</h4>
                <div class="mt-5">
                    <div class="row mb-5 mt-6">
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('expiryMailFromEmail')?.invalid && mailKitForm.get('expiryMailFromEmail')?.touched && !isReadOnly()}">Expiry
                                Mail From</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('expiryMailFromEmail')?.invalid && mailKitForm.get('expiryMailFromEmail')?.touched && !isReadOnly()}"
                                formControlName="expiryMailFromEmail" placeholder="" name="expiryMailFromEmail"
                                maxlength="64" />
                            @if (mailKitForm.get('expiryMailFromEmail')?.invalid &&
                            mailKitForm.get('expiryMailFromEmail')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('expiryMailFromEmail')?.errors?.['required']) {
                                From is required.
                                }
                                @else if (mailKitForm.get('expiryMailFromEmail')?.errors?.['pattern']) {
                                From must be alphanumeric.
                                }@else if (mailKitForm.get('expiryMailFromEmail')?.errors?.['maxlength']) {
                                From must be no longer than 64 characters.
                                }
                            </span>
                            }
                        </div>
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('expiryMailFromName')?.invalid && mailKitForm.get('expiryMailFromName')?.touched && !isReadOnly()}">Expiry
                                From Name</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('expiryMailFromName')?.invalid && mailKitForm.get('expiryMailFromName')?.touched && !isReadOnly()}"
                                formControlName="expiryMailFromName" placeholder="" name="expiryMailFromName"
                                maxlength="64" />
                            @if (mailKitForm.get('expiryMailFromName')?.invalid &&
                            mailKitForm.get('expiryMailFromName')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('expiryMailFromName')?.errors?.['required']) {
                                From Name is required.
                                }
                                @else if (mailKitForm.get('expiryMailFromName')?.errors?.['pattern']) {
                                From Name must be alphanumeric.
                                }@else if (mailKitForm.get('expiryMailFromName')?.errors?.['maxlength']) {
                                From Name must be no longer than 64 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                    <div class="row mb-5 mt-6">
                        <div class="col-12 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('expiryMailSubject')?.invalid && mailKitForm.get('expiryMailSubject')?.touched && !isReadOnly()}">Subject</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('expiryMailSubject')?.invalid && mailKitForm.get('expiryMailSubject')?.touched && !isReadOnly()}"
                                formControlName="expiryMailSubject" placeholder="" name="expiryMailSubject"
                                maxlength="256" />
                            @if (mailKitForm.get('expiryMailSubject')?.invalid &&
                            mailKitForm.get('expiryMailSubject')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('expiryMailSubject')?.errors?.['required']) {
                                Subject is required.
                                }
                                @else if (mailKitForm.get('expiryMailSubject')?.errors?.['pattern']) {
                                Subject must be alphanumeric.
                                }@else if (mailKitForm.get('expiryMailSubject')?.errors?.['maxlength']) {
                                Subject must be no longer than 256 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                    <div class="row mb-5 mt-6">
                        <div class="col-12 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('expiryMailBody')?.invalid && mailKitForm.get('expiryMailBody')?.touched && !isReadOnly()}">Mail
                                Body</label>
                            <textarea type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('expiryMailBody')?.invalid && mailKitForm.get('expiryMailBody')?.touched && !isReadOnly()}"
                                rows="4" maxlength="256" formControlName="expiryMailBody" placeholder=""
                                name="expiryMailBody"></textarea>
                            @if (mailKitForm.get('expiryMailBody')?.invalid &&
                            mailKitForm.get('expiryMailBody')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('expiryMailBody')?.errors?.['required']) {
                                Mail Body is required.
                                }@else if (mailKitForm.get('expiryMailBody')?.errors?.['maxlength']) {
                                Mail Body must be no longer than 256 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div class="px-2 mt-5">
                <h4 class="mb-5">Renewal Mail</h4>
                <div class="mt-5">
                    <div class="row mb-5 mt-6">
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('renewalMailFromEmail')?.invalid && mailKitForm.get('renewalMailFromEmail')?.touched && !isReadOnly()}">From</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('renewalMailFromEmail')?.invalid && mailKitForm.get('renewalMailFromEmail')?.touched && !isReadOnly()}"
                                formControlName="renewalMailFromEmail" placeholder="" name="renewalMailFromEmail"
                                maxlength="64" />
                            @if (mailKitForm.get('renewalMailFromEmail')?.invalid &&
                            mailKitForm.get('renewalMailFromEmail')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('renewalMailFromEmail')?.errors?.['required']) {
                                From is required.
                                }
                                @else if (mailKitForm.get('renewalMailFromEmail')?.errors?.['pattern']) {
                                From must be alphanumeric.
                                }@else if (mailKitForm.get('renewalMailFromEmail')?.errors?.['maxlength']) {
                                From must be no longer than 64 characters.
                                }
                            </span>
                            }
                        </div>
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('renewalMailFromName')?.invalid && mailKitForm.get('renewalMailFromName')?.touched && !isReadOnly()}">From
                                Name</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('renewalMailFromName')?.invalid && mailKitForm.get('renewalMailFromName')?.touched && !isReadOnly()}"
                                formControlName="renewalMailFromName" placeholder="" name="renewalMailFromName"
                                maxlength="64" />
                            @if (mailKitForm.get('renewalMailFromName')?.invalid &&
                            mailKitForm.get('renewalMailFromName')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('renewalMailFromName')?.errors?.['required']) {
                                From Name is required.
                                }
                                @else if (mailKitForm.get('renewalMailFromName')?.errors?.['pattern']) {
                                From Name must be alphanumeric.
                                }@else if (mailKitForm.get('renewalMailFromName')?.errors?.['maxlength']) {
                                From Name must be no longer than 64 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                    <div class="row mb-5 mt-6">
                        <div class="col-12 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('renewalMailSubject')?.invalid && mailKitForm.get('renewalMailSubject')?.touched && !isReadOnly()}">Subject</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('renewalMailSubject')?.invalid && mailKitForm.get('renewalMailSubject')?.touched && !isReadOnly()}"
                                formControlName="renewalMailSubject" placeholder="" name="renewalMailSubject"
                                maxlength="256" />
                            @if (mailKitForm.get('renewalMailSubject')?.invalid &&
                            mailKitForm.get('renewalMailSubject')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('renewalMailSubject')?.errors?.['required']) {
                                Subject is required.
                                }
                                @else if (mailKitForm.get('renewalMailSubject')?.errors?.['pattern']) {
                                Subject must be alphanumeric.
                                }@else if (mailKitForm.get('renewalMailSubject')?.errors?.['maxlength']) {
                                Subject must be no longer than 256 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                    <div class="row mb-5 mt-6">
                        <div class="col-12 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('renewalMailBody')?.invalid && mailKitForm.get('renewalMailBody')?.touched && !isReadOnly()}">Mail
                                Body</label>
                            <textarea type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('renewalMailBody')?.invalid && mailKitForm.get('renewalMailBody')?.touched && !isReadOnly()}"
                                rows="4" maxlength="256" formControlName="renewalMailBody" placeholder=""
                                name="renewalMailBody"></textarea>
                            @if (mailKitForm.get('renewalMailBody')?.invalid &&
                            mailKitForm.get('renewalMailBody')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('renewalMailBody')?.errors?.['required']) {
                                Mail Body is required.
                                }@else if (mailKitForm.get('renewalMailBody')?.errors?.['maxlength']) {
                                Mail Body must be no longer than 256 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                </div>
            </div>

             <div class="px-2 mt-5">
                <h4 class="mb-5">Message Mail</h4>
                <div class="mt-5">
                    <div class="row mb-5 mt-6">
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('messageFromEmail')?.invalid && mailKitForm.get('messageFromEmail')?.touched && !isReadOnly()}">From</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('messageFromEmail')?.invalid && mailKitForm.get('messageFromEmail')?.touched && !isReadOnly()}"
                                formControlName="messageFromEmail" placeholder="" name="messageFromEmail"
                                maxlength="64" />
                            @if (mailKitForm.get('messageFromEmail')?.invalid &&
                            mailKitForm.get('messageFromEmail')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('messageFromEmail')?.errors?.['required']) {
                                From is required.
                                }
                                @else if (mailKitForm.get('messageFromEmail')?.errors?.['pattern']) {
                                From must be alphanumeric.
                                }@else if (mailKitForm.get('messageFromEmail')?.errors?.['maxlength']) {
                                From must be no longer than 64 characters.
                                }
                            </span>
                            }
                        </div>
                        <div class="col-12 col-md-6 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('messageToEmail')?.invalid && mailKitForm.get('messageToEmail')?.touched && !isReadOnly()}">To</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('messageToEmail')?.invalid && mailKitForm.get('messageToEmail')?.touched && !isReadOnly()}"
                                formControlName="messageToEmail" placeholder="" name="messageToEmail"
                                maxlength="64" />
                            @if (mailKitForm.get('messageToEmail')?.invalid &&
                            mailKitForm.get('messageToEmail')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('messageToEmail')?.errors?.['required']) {
                                To is required.
                                }
                                @else if (mailKitForm.get('messageToEmail')?.errors?.['pattern']) {
                                To must be alphanumeric.
                                }@else if (mailKitForm.get('messageToEmail')?.errors?.['maxlength']) {
                                To must be no longer than 64 characters.
                                }
                            </span>
                            }
                        </div>
                        
                    </div>
                    <div class="row mb-5 mt-6">
                        <div class="col-12 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('messageMailSubject')?.invalid && mailKitForm.get('messageMailSubject')?.touched && !isReadOnly()}">Subject</label>
                            <input type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('messageMailSubject')?.invalid && mailKitForm.get('messageMailSubject')?.touched && !isReadOnly()}"
                                formControlName="messageMailSubject" placeholder="" name="messageMailSubject"
                                maxlength="256" />
                            @if (mailKitForm.get('messageMailSubject')?.invalid &&
                            mailKitForm.get('messageMailSubject')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('messageMailSubject')?.errors?.['required']) {
                                Subject is required.
                                }
                                @else if (mailKitForm.get('messageMailSubject')?.errors?.['pattern']) {
                                Subject must be alphanumeric.
                                }@else if (mailKitForm.get('messageMailSubject')?.errors?.['maxlength']) {
                                Subject must be no longer than 256 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                    <div class="row mb-5 mt-6">
                        <div class="col-12 mb-5 form-container">
                            <label class="form-label form-label-floating mb-3 required"
                                [ngClass]="{'border-danger': mailKitForm.get('messageMailBody')?.invalid && mailKitForm.get('messageMailBody')?.touched && !isReadOnly()}">Mail
                                Body</label>
                            <textarea type="text" class="form-control form-control-lg form-control-solid" [readOnly]="isReadOnly()"
                                [ngClass]="{'border-danger': mailKitForm.get('messageMailBody')?.invalid && mailKitForm.get('messageMailBody')?.touched && !isReadOnly()}"
                                rows="4" maxlength="1024" formControlName="messageMailBody" placeholder=""
                                name="messageMailBody"></textarea>
                            @if (mailKitForm.get('messageMailBody')?.invalid &&
                            mailKitForm.get('messageMailBody')?.touched && !isReadOnly()) {
                            <span class="text-danger">
                                @if (mailKitForm.get('messageMailBody')?.errors?.['required']) {
                                Mail Body is required.
                                }@else if (mailKitForm.get('messageMailBody')?.errors?.['maxlength']) {
                                Mail Body must be no longer than 1024 characters.
                                }
                            </span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <mat-action-row class="accordion-footer d-flex justify-content-end py-5 px-6">
        <button mat-button type="button" class="btn btn-lg btn-light-primary me-3 back-btn" (click)="cancelClick()">Cancel</button>
        <button mat-button type="button" class="btn btn-lg btn-primary continue-btn"
            (click)="onMailConfigSubmit()" [disabled]="isReadOnly()">Save</button>
    </mat-action-row>
</ng-container>